import { put, takeLatest, all } from 'redux-saga/effects';
import { isAuthorized } from 'src/features/permissions/utils/permissionUtils';
import { PERM_PERSON, PERM_WRITE, PERM_HOURLY_PERSON } from 'src/features/permissions/utils/constants';
import {
  ACCOUNT_SETTINGS_COLLECT_FIELDS_BEGIN,
  ACCOUNT_SETTINGS_COLLECT_FIELDS_SUCCESS,
  ACCOUNT_SETTINGS_COLLECT_FIELDS_FAILURE,
  ACCOUNT_SETTINGS_COLLECT_FIELDS_DISMISS_ERROR,
} from './constants';

import { doGetPersonFields } from './getPersonFields';
import { doGetProjectFields } from './getProjectFields';
import { doGetRoleNames } from './getRoleNames';
import { doGetSkillSet } from './getSkillSet';
import { doGetHourlyPersonFields } from './getHourlyPersonFields';
import { doGetPersonFieldValues } from '../../people/redux/getPersonFieldValues';
import { doGetProjectFieldValues } from '../../projects/redux/getProjectFieldValues';
import { doGetHourlyPeopleFieldValues } from '../../self-perform/redux/getHourlyPeopleFieldValues';

export function collectFields(accountId, permissions) {
  return {
    type: ACCOUNT_SETTINGS_COLLECT_FIELDS_BEGIN,
    accountId,
    permissions,
  };
}

export function dismissCollectFieldsError() {
  return {
    type: ACCOUNT_SETTINGS_COLLECT_FIELDS_DISMISS_ERROR,
  };
}

export function* doCollectFields(action) {
  const { accountId, permissions } = action;
  const accountParam = { accountId };

  const hasPersonPermissions = isAuthorized(accountId, permissions, PERM_WRITE, PERM_PERSON);
  const hasHourlyPersonPermissions = isAuthorized(accountId, permissions, PERM_WRITE, PERM_HOURLY_PERSON);

  try {
    yield all([
      doGetPersonFields(accountParam),
      doGetProjectFields(accountParam),
      doGetRoleNames(accountParam),
      ...(hasPersonPermissions ? [
        doGetPersonFieldValues(accountParam),
        doGetProjectFieldValues(accountParam),
      ]
        : []),
      ...(hasHourlyPersonPermissions
        ? [
          doGetHourlyPersonFields(accountParam),
          doGetSkillSet(accountParam),
          doGetHourlyPeopleFieldValues(accountParam),
        ]
        : []),
    ]);
  } catch (err) {
    yield put({
      type: ACCOUNT_SETTINGS_COLLECT_FIELDS_FAILURE,
      data: { error: err },
    });
    return;
  }

  yield put({
    type: ACCOUNT_SETTINGS_COLLECT_FIELDS_SUCCESS,
  });
}

export function* watchCollectFields() {
  yield takeLatest(ACCOUNT_SETTINGS_COLLECT_FIELDS_BEGIN, doCollectFields);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case ACCOUNT_SETTINGS_COLLECT_FIELDS_BEGIN:
      return {
        ...state,
        collectFieldsPending: true,
        collectFieldsError: null,
      };

    case ACCOUNT_SETTINGS_COLLECT_FIELDS_SUCCESS:
      return {
        ...state,
        collectFieldsPending: false,
        collectFieldsError: null,
      };

    case ACCOUNT_SETTINGS_COLLECT_FIELDS_FAILURE:
      return {
        ...state,
        collectFieldsPending: false,
        collectFieldsError: action.data.error,
      };

    case ACCOUNT_SETTINGS_COLLECT_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        collectFieldsError: null,
      };

    default:
      return state;
  }
}
